import React from 'react';
import '../../../../css/common/chat/ChatAnnouncements.css';

const formatAnnouncementTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('ja-JP', {
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const ChatAnnouncementBar = ({
  announcement = null,
  count = 0,
  onOpenList = null,
  className = '',
}) => {
  if (!announcement) return null;
  const wrapperClassName = ['chat-announcement-bar', className].filter(Boolean).join(' ');
  return (
    <div className={wrapperClassName}>
      <div className="chat-announcement-bar__icon" aria-hidden="true">
        <i className="fa-solid fa-bullhorn"></i>
      </div>
      <div className="chat-announcement-bar__body">
        <div className="chat-announcement-bar__preview">{announcement.preview || 'アナウンス'}</div>
        <div className="chat-announcement-bar__time">{formatAnnouncementTime(announcement.announcedAt)}</div>
      </div>
      <button
        type="button"
        className="chat-announcement-bar__toggle"
        onClick={onOpenList}
        aria-label="アナウンス一覧を開く"
        title="アナウンス一覧を開く"
      >
        {count > 1 ? <span className="chat-announcement-bar__count">{count}</span> : null}
        <i className="fa-solid fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
  );
};

export default ChatAnnouncementBar;
